import { load as loadReCaptcha, type ReCaptchaInstance } from 'recaptcha-v3'

type RecaptchaAction = 'notify_me'

type UseRecaptcha = {
  execute: (action: RecaptchaAction) => Promise<{ token: string }>
}

/**
 * Loads the recaptcha script and returns a helper method to execute a recaptcha.
 */
export default async function (): Promise<UseRecaptcha> {
  const config = useRuntimeConfig()
  const app = useNuxtApp()
  const language = useCurrentLanguage()
  const country = useCurrentCountry()

  // Makes sure the loading is only done once.
  await callOnce(async () => {
    // Initialize recaptcha.
    app._recaptchaInstance = await loadReCaptcha(
      config.public.recaptchaSiteKey,
      {
        autoHideBadge: true,
        useRecaptchaNet: true,
        renderParameters: {
          hl: `${language.value}-${country.value}`,
        },
      },
    )
  })

  const execute = async (action: RecaptchaAction) => {
    const token = await app._recaptchaInstance.execute(action)
    return { token }
  }
  return { execute }
}

declare module '#app' {
  interface NuxtApp {
    _recaptchaInstance: ReCaptchaInstance
  }
}
